// import { height, width } from "@fortawesome/free-solid-svg-icons/fa0";
import React from "react";

const TopNav = () => {
  let flag = 0;

  const openmenu = () => {
    let menubar = document.querySelector(".menu-bar");
    if (flag === 0) {
      menubar.style.display = "block";
      flag = 1;
    } else {
      menubar.style.display = "none";
      flag = 0;
    }
  };

  return (
    <>
      <div className="toptop">
        <div className="tonavbar1">
          <img
            className="mainlogo"
            styles={{}} src="./logo1-rbg.png" alt="logo" />
          <div className="tonavbar2">
            <img src="./logo2-rbg.png" alt="logo" />
            {/*   <img style={{ height: "50px ", width: "200px", marginLeft: "300px" }} src="./small-wonder-school.png" alt="" /> */}

            <p >Small Wonder World Play School</p>
          </div>
          {/* <div className="imp">
            <h1 style={{color:"#ffffff"}}>
            Bhopal academy co-ed hr sec school     small-wonder-school.png
            </h1> */}
          {/* <h1 style={{ color: "#ffff" }}>
              <span id="firsth">N</span>EW <span id="firsth">W</span>ISDOM{" "}
              <span id="firsth">P</span>UBLIC{" "}
              <span id="firsth">S</span>CHOOL
            </h1 > */}
          {/* <p  style={{ color: "#ffff" }}>Learning today. Leading tomorrow. Inspired Forever.</p>
          </div> */}
          <img style={{ borderRadius: '30px' }} src="/bg-remove.webp" alt="#" />
        </div>

      </div>
      <div className="menuimageicon">
        <i class="ri-menu-line" onClick={() => openmenu()}></i>
      </div>
    </>
  );
};

export default TopNav;
